import * as React from 'react';
import { CityWithLocations } from 'lib/types';
import useLocationsWithImages from 'locations/hooks/useLocationsWithImages';
import useCities from './useCities';

// this hook only returns cities that have at least 1 location
export default function useCitiesWithLocations(): ReadonlyArray<CityWithLocations> {
    const cities = useCities();
    const locations = useLocationsWithImages();

    return React.useMemo(() => {
        return cities.reduce<ReadonlyArray<CityWithLocations>>(
            (aggregator, city) => {
                const cityLocations = locations.filter(
                    (location) => location.city?.id === city.id,
                );

                if (cityLocations.length > 0) {
                    return [
                        ...aggregator,
                        {
                            ...city,
                            locations: cityLocations,
                        },
                    ];
                }

                return aggregator;
            },
            [],
        );
    }, [cities, locations]);
}
